// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__1NSZu","round":"Image_round__3jext"};